export const SAMPLE = { name: "Alex Morgan", first_name: "Alex", company: "Acme Ltd", email: "alex@acme.com", title: "Head of Sales" };

const esc = (s) => s.replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
const logoTag = (url) => (url ? `<img src="${url}" alt="Logo" style="max-width:200px;max-height:80px;height:auto;border:0;display:inline-block">` : "");

export const merge = (t, logoUrl = "") =>
  (t || "").replace(/\{\{?\s*(name|first_name|company|email|title|logo)\s*\}?\}/gi, (_, k) =>
    k.toLowerCase() === "logo" ? logoTag(logoUrl) : SAMPLE[k.toLowerCase()]);

export const mergeSubject = (t) => merge((t || "").replace(/\{\{?\s*logo\s*\}?\}/gi, ""));

const FOOTER = '<p style="font-family:Arial,sans-serif;font-size:12px;color:#6b7280;margin-top:28px;border-top:1px solid #e5e7eb;padding-top:12px">Footer text · <a href="#" style="color:#6b7280">Unsubscribe</a> (added automatically)</p>';

export function previewDoc(body, format, logoUrl) {
  if (format === "html") {
    const b = merge(body, logoUrl);
    return /<\/body>/i.test(b) ? b.replace(/<\/body>/i, `${FOOTER}</body>`) : b + FOOTER;
  }
  return `<div style="font-family:Arial,Helvetica,sans-serif;font-size:15px;line-height:1.6;color:#111827">${merge(esc(body || ""), logoUrl).replace(/\n/g, "<br>")}</div>${FOOTER}`;
}

export function EmailFrame({ body, format, logoUrl, height = 420, testId }) {
  return (
    <iframe title="Email preview" sandbox="" srcDoc={previewDoc(body, format, logoUrl)} data-testid={testId}
      className="w-full rounded-lg bg-white border border-border" style={{ height }} />
  );
}
